<template>
    <div id="video-grade-accounting">
        <div class="second-header-wrap">
            <el-button type="default" @click="$router.back()" size="medium">返回</el-button>
            <div class="resource-name">{{resourceName}}</div>
        </div>
        <div class="general-container">
            <div class="select-container">
                学年：
                <el-select v-model="termId" @change="termChangeHandler" placeholder="请选择学年">
                    <el-option
                        v-for="item in termList"
                        :key="item.id"
                        :label="item.schoolYear"
                        :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <el-table
                :data="gradeDataList"
                style="width: 100%">
                <el-table-column type="expand" width="50px">
                    <template slot-scope="props">
                        <div class="sub-table">
                            <el-table style="width: 100%;"
                                      :data="props.row.classViewList">
                                <el-table-column width="50px">
                                </el-table-column>
                                <el-table-column
                                    label="班级"
                                >
                                    <template slot-scope="subprops">
                                        <div class="class-name">{{subprops.row.className}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="学生已看"
                                    prop="readCount"
                                >
                                    <!--<template slot-scope="scope">-->
                                    <!--<router-link v-if="scope.row.readCount !== 0" :to="{path: 'videoWatchList', query: {schoolId: scope.row.schoolId, resourceId, type: 'student'}}">-->
                                    <!--{{scope.row.readCount}}-->
                                    <!--</router-link>-->
                                    <!--<span v-else>0</span>-->
                                    <!--</template>-->
                                </el-table-column>
                                <el-table-column
                                    label="学生未看"
                                    prop="notReadCount"
                                >
                                    <!--<template slot-scope="scope">-->
                                    <!--<router-link v-if="scope.row.notReadCount !== 0" :to="{path: 'videoNotWatchList', query: {schoolId: scope.row.schoolId, resourceId, type: 'student'}}">-->
                                    <!--{{scope.row.notReadCount}}-->
                                    <!--</router-link>-->
                                    <!--<span v-else>0</span>-->
                                    <!--</template>-->
                                </el-table-column>
                                <el-table-column
                                    label="观看比例"
                                >
                                    <template slot-scope="scope">
                                        <div>{{calcPercent(scope.row.readCount, scope.row.readCount + scope.row.notReadCount)}}%</div>
                                        <div class="progress-bar">
                                            <div class="progress-bar__full" :style="{width: `${calcPercent(scope.row.readCount, scope.row.readCount + scope.row.notReadCount)}%`}"></div>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="年级"
                    prop="gradeName"
                >
                </el-table-column>
                <el-table-column
                    label="学生已看"
                    prop="readCount"
                >
                    <!--<template slot-scope="scope">-->
                        <!--<router-link v-if="scope.row.readCount !== 0" :to="{path: 'videoWatchList', query: {schoolId: scope.row.schoolId, resourceId, type: 'student'}}">-->
                            <!--{{scope.row.readCount}}-->
                        <!--</router-link>-->
                        <!--<span v-else>0</span>-->
                    <!--</template>-->
                </el-table-column>
                <el-table-column
                    label="学生未看"
                    prop="notReadCount"
                >
                    <!--<template slot-scope="scope">-->
                        <!--<router-link v-if="scope.row.notReadCount !== 0" :to="{path: 'videoNotWatchList', query: {schoolId: scope.row.schoolId, resourceId, type: 'student'}}">-->
                            <!--{{scope.row.notReadCount}}-->
                        <!--</router-link>-->
                        <!--<span v-else>0</span>-->
                    <!--</template>-->
                </el-table-column>
                <el-table-column
                    label="观看比例"
                >
                    <template slot-scope="scope">
                        <div>{{calcPercent(scope.row.readCount, scope.row.readCount + scope.row.notReadCount)}}%</div>
                        <div class="progress-bar">
                            <div class="progress-bar__full" :style="{width: `${calcPercent(scope.row.readCount, scope.row.readCount + scope.row.notReadCount)}%`}"></div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {
        setSchoolYearAndTermList,
        getSchoolGradeResourceViewDataList,
        getSchoolClassResourceViewDataList
    } from '@/api/accounting/accounting';

    export default {
        name: "video-grade-accounting",
        data() {
            return {
                schoolId: this.$route.query.schoolId,
                resourceId: this.$route.query.resourceId,
                resourceName: this.$route.query.resourceName,
                termId: 0,
                termList: [],
                gradeDataList: []
            }
        },
        created() {
            setSchoolYearAndTermList({
                schoolId: this.schoolId
            })
                .then(res =>res.data)
                .then(data =>{
                    if(data.data.length !== 0) {
                        this.termList = data.data;
                        this.termId = data.data.find(item => item.isCurrent === 1).id;
                        this.getSchoolGradeResourceViewDataListFunc();
                    }
                });
        },
        methods: {
            calcPercent(value1, value2) {
                if(value2 === 0) {
                    return 0;
                } else {
                    const percent = value1 / value2 * 100;
                    return percent.toFixed(2);
                }
            },
            getSchoolGradeResourceViewDataListFunc() {
                getSchoolGradeResourceViewDataList({
                    schoolId: this.schoolId,
                    resourceId: this.resourceId,
                    termId: this.termId
                })
                    .then(res => res.data)
                    .then(data => {
                        this.gradeDataList = data.data;
                        console.log(this.gradeDataList)
                    })
            },
            termChangeHandler() {
                this.getSchoolGradeResourceViewDataListFunc();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";

    @include reset-global;

    .second-header-wrap {
        position: fixed;
        top: 90px;
        left: 12%;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        background-color: #fff;
        z-index: 1000;
    }
    .resource-name {
        @include middleIB;
        font-size: 22px;
        width: 60%;
        text-align: center;
    }
    .general-container {
        width: 1320px;
        min-height: 560px;
        margin-top: 72px;
    }
    .select-container {

        padding: 5px 4%;
    }
    .progress-bar {
        width: 100%;
        height: 5px;
        background-color: #ddd;
        position: relative;
        .progress-bar__full {
            position: absolute;
            height: 100%;
            left: 0;
            top: 0;
            background-color: #20a0ff;
        }
    }
</style>
<style lang="scss">
    #video-grade-accounting .cell {
        text-align: center !important;
    }
    #video-grade-accounting a {
        color: #20a0ff !important;
        text-decoration: none;
    }
    #video-grade-accounting {
        .el-table__expanded-cell {
            padding: 0 !important;
        }
        .sub-table {
            .el-table__header-wrapper {
                display: none;
            }
        }
        .class-name {
            text-indent: 4em;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/accounting/videoGradeAccounting.vue